module.exports = __webpack_public_path__ + "img/HT.db5f116d.png";